import { Navigate, useLocation } from 'react-router-dom';
import { ReactNode } from 'react';

interface PrivateRouteProps {
  children: ReactNode;
  roles?: string[];
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ children, roles }) => {
  const token = localStorage.getItem('token');
  const userStr = localStorage.getItem('user');
  const location = useLocation();

  if (!token) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  if (roles && userStr) {
    try {
      const user = JSON.parse(userStr);
      if (!roles.includes(user.role)) {
        // User not authorized for this route
        return <Navigate to="/" replace />;
      }
    } catch (e) {
      console.error("Error parsing user data", e);
      return <Navigate to="/login" replace />;
    }
  }

  return <>{children}</>;
};

export default PrivateRoute;